/*
 * File: PatientSearch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles searching for a patient
 */
import React, { Component } from "react";
import { observer } from "mobx-react";
import UISearch from "components/ui/UISearch";
import UISnackbar from "components/ui/UISnackbar";
import PropTypes from "prop-types";

class PatientSearch extends Component {
  state = { error: false };

  constructor(props) {
    super(props);
    this.store = props.store;
  }

  saveKeyword = keyword => {
    this.setState({ error: false });

    //If keyword has been cleared out, call clearSearch
    if (keyword === undefined || keyword.length === 0) {
      this.store.clearSearch();
    } else {
      this.store.setKeyword(keyword);
    }
  };

  search = () => {
    if (this.store.keyword.trim().length < 2) {
      this.setState({ error: true });
    } else {
      this.store.search(this.store.keyword);
    }
  };

  clearSearch = () => {
    this.store.clearSearch();
  };

  render() {
    let { error } = this.state;
    return (
      <div className="sub-toolbar">
        <UISnackbar
          message="Please enter more than 2 characters"
          open={error}
          variant="error"
        />
        <UISearch
          autoFocus={true}
          placeholder="Search for a patient..."
          keyword={this.store.keyword}
          parentOnChange={this.saveKeyword}
          parentOnSubmit={this.search}
        />
      </div>
    );
  }
}

PatientSearch.propTypes = {
  store: PropTypes.object.isRequired
};

export default observer(PatientSearch);
